import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('createAssetForm');

    return {
        BATTERY_BUTTON_TEXT: t('batteryButtonText'),
        DRONE_BUTTON_TEXT: t('droneButtonText')
    };
};

export default useTranslation;
